export default __webpack_public_path__ + "static/media/Salvio.4f69a357.jpg";